module.exports = __webpack_public_path__ + "detaile_banner.97a3344e.png";